import type { ReactNode } from "react";

type SettingsModalFooterProps = {
  leading?: ReactNode;
  leadingClassName?: string;
  actions: ReactNode;
};

export function SettingsModalFooter({
  leading,
  leadingClassName = "text-sm leading-5 text-[#757575]",
  actions,
}: SettingsModalFooterProps) {
  if (!leading) {
    return <div className="flex w-full justify-end gap-4">{actions}</div>;
  }

  return (
    <div className="flex w-full flex-wrap items-center justify-between gap-4">
      <div className={leadingClassName}>{leading}</div>
      <div className="flex shrink-0 items-center gap-4">{actions}</div>
    </div>
  );
}
